export const UrlPath ={
  authCodeUrl:'/api/v1/google/token?webRequest=true',
  tokenUrl: '/oauth/token',
  sendOTPUrl: '/api/v1/signin/sendOtp',
  validateOTPUrl: '/api/v1/signin/validateOtp',
  userLoginUrl:'/api/v1/signin/validate/credentials',
  resetPwUrl:'/api/v1/signin/change/password'
}
export const MessageType = {
  ERROR: 'error',
  SUCCESS: 'success'
}
export const messages = {
  user_info_error: 'Failed to get user from server',
  auth_token_error: 'Failed to get auth token from server.',
  google_code_error: 'Failed to get code from google services'
}
